import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

import { OptionInterface } from '../../../shared/interfaces';
import { WarehouseApiService } from '../../../shared/services/api/warehouse.service';

@Component({
  selector: 'lum-filter-warehouse',
  templateUrl: './filter-warehouse.component.html',
  styleUrls: ['./filter-warehouse.component.scss'],
})
export class FilterWarehouseComponent implements OnInit {
  @Input()
  queryId :string = 'warehouse';

  @Input()
  value :number[] = [];

  @Input()
  label :string = 'Warehouse';

  @Input()
  placeholder :string = 'Warehouse';

  @Input()
  multiple :boolean = false;

  @Output()
  onFilterSelect :EventEmitter<any[] | any> = new EventEmitter<any>();

  items :OptionInterface[];
  items$ :Observable<OptionInterface[]>;
  private onDestroy$ = new Subject();

  constructor(private warehouseApiService :WarehouseApiService) {}

  ngOnInit() :void {
    this.getFromService();
    this.warehouseApiService.getWarehouses({});
    this.getItemsFromObservable().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  private getFromService() :void {
    this.items$ = this.warehouseApiService.warehouses$;
  }

  private getItemsFromObservable() :Observable<OptionInterface[]> {
    return this.items$.pipe(
      tap((items :OptionInterface[]) => {
        this.items = items;
      }),
      takeUntil(this.onDestroy$),
    );
  }

  onSelectOptionEvent(event :any) :void {
    this.onFilterSelect.emit({
      [this.queryId]: event,
    });
  }
}
